<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col-12">
      <legend class="usa-legend usa-legend--large">S3 Admin Portal</legend>
    </div>
  </div>

  <form [formGroup]="this.s3protalFormControl">
    <tabset>
      <tab heading="Search S3" id="search">
        <div class="grid-row grid-gap">
          <div class="grid-col-4">
            <label for="prefix" class="usa-label">Search By Prefix</label>
            <input id="prefix" type="text" id="searchS3Prefix" formControlName="searchPrefix" class="usa-input w-100"
                   (keydown.enter)="$event.preventDefault()">
          </div>
        </div>
        <div class="grid-row grid-gap margin-top-2">
          <div class="grid-col-4">

          <button type="button" class="usa-button"
                  (click)="searchByPrefix()">Search</button>
          </div>
        </div>
      </tab>
      <tab heading="Create Empty Folder" id="create">
        <div class="grid-row grid-gap">
          <div class="grid-col-4">
            <label for="uploadPathExisting" class="usa-label">Create Empty Folder:</label>
            <input type="text" id="uploadPathExisting" formControlName="existingPath" [attr.disabled]='true' class="usa-input w-100">
          </div>
          <div class="grid-col-1">
            <label for="prefix" class="usa-label" style="visibility: hidden;">C</label>
            /
          </div>
          <div class="grid-col-4">
            <label for="uploadPath" class="usa-label" style="visibility: hidden;">Create Empty Folder:</label>
            <input type="text" id="uploadPath" formControlName="key" class="usa-input w-100">
          </div>
        </div>
        <div class="grid-row grid-gap margin-top-2">
          <div class="grid-col-4">
            <button type="button"  (click)="createEmptyObject()" class="usa-button">Create Folder
            </button>
          </div>
        </div>
      </tab>
      <tab heading="Upload File" id="uploadS3">
        <div class="grid-row grid-gap">
          <div class="grid-col-4">
            <label for="upload" class="usa-label">Upload A File To Folder:</label>
            <input type="text" id="upload" formControlName="existingUploadPath" [attr.disabled]='true' class="usa-input w-100">
          </div>
          <div class="grid-col-4">
            <label for="selectFile" class="usa-label" style="visibility: hidden;">Select A File:</label>
            <input id="selectFile" #Image type="file" (change)="handleFileInput($event)" class="usa-input w-100"/>
          </div>
        </div>
        <div class="grid-row grid-gap margin-top-2">
          <div class="grid-col-4">
            <button type="button" (click)="onUploadFile()" class="usa-button">Upload</button>
          </div>
        </div>
      </tab>
      <tab heading="Remove File or Folder" id="remove">
        <div class="grid-row grid-gap">
          <div class="grid-row grid-gap margin-top-2">
            <button (click)="removeSelected()" class="usa-button">Remove Selected</button>
          </div>
        </div>
        <div class="grid-row grid-gap margin-top-2">
          <div class="usa-alert usa-alert--info usa-alert--no-icon">
            <div class="usa-alert__body">
              <p class="usa-alert__text">
                Please select a row to delete.
              </p>
           </div>
        </div>
   </div>
      </tab>
    </tabset>
  </form>
  <div class="grid-row grid-gap margin-top-4">
    <ag-grid-angular
      style="width: 100%; height: 400px;"
      class="ag-theme-alpine"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [autoGroupColumnDef]="autoGroupColumnDef"
      [rowData]="rowData"
      [treeData]="true"
      [animateRows]="true"
      [rowSelection]="rowSelection"
      [groupDefaultExpanded]="groupDefaultExpanded"
      (selectionChanged)="onSelectionChanged($event)"
      [getDataPath]="getDataPath"
      [getRowNodeId]="getRowId"
      (gridReady)="onGridReady($event)"
    ></ag-grid-angular>
  </div>
  <button type="button" class="usa-button" (click)="viewAuditTrial()">View Audit Trail</button>
</div>


